import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
import Item from '../../components/Item';

import './styles.css';

const messages = defineMessages({
  noResults: {
    id: 'repvisits.overview.noneFound',
    defaultMessage: 'No appointments found.',
  },
});

const NoResults = () => (
  <Item.Group styleName="no-results-container">
    <Item>
      <Item.Content>
        <Item.Description><FormattedMessage {...messages.noResults} /></Item.Description>
      </Item.Content>
    </Item>
  </Item.Group>
);

export default NoResults;
